<template>
  <div id="modal-menu">
    <div class="modal-content">
      <button type="button" class="close close-left" data-dismiss="modal" aria-label="Close" @click="$emit('close')" style="z-index: 101;">
        <span aria-hidden="true">×</span></button>
      <form id="form-add-menu" method="post" action="">
        <div class="modal-body display-flex flex-column">
          <div class="modal-head pb-20">
            <div class="image-cover sides">
              <div class="app-only-deals item-app-only-deals" v-if="isAppOnly">
                <div class="container-blur"></div>
                <div class="ribbona ribbona-app-only" style="z-index: 101;">
                  <span>{{ $t('app_only')}} </span>
                </div>
                <img class="hidden-sm hidden-xs" v-if="menu.image" v-bind:src="menu.image.desktop_detail">
                <img class="hidden-lg" v-if="menu.image" v-bind:src="menu.image.mobile_detail">
              </div>
              <div v-else>
                <img class="hidden-sm hidden-xs" v-if="menu.image" v-bind:src="menu.image.desktop_detail">
                <img class="hidden-lg" v-if="menu.image" v-bind:src="menu.image.mobile_detail">
              </div>
            </div>
            <h1 class="t22 fw600 title-name">{{ menu.name }}</h1>
            <div class="flex flex-row flex-wrap pt-10 pb-10">
              <div v-for="(img, indeximg) in menu.menu_attributes" :key="indeximg" class="pl-10">
                <img alt="" v-bind:src="img.image.icon"  width="30" class="pl-5" />
                {{img.name}}
              </div>
            </div>

            <!--<p class="t13 fw300 pr10 pt10 text-black" style="">-->
              <!--<nl2br v-if="menu.marketing_description" tag="p" :text="menu.marketing_description" /></p>-->
            <p class="t13 fw300 pr10 pt10 text-black" style="">
              <nl2br v-if="menu.main_description" tag="p" :text="menu.main_description" /></p>
            <div role="button" @click="showAccordionTC = !showAccordionTC" v-if="t_c_desc">
              <h6 class="panel-title">
                <i class="fa fa-caret-down" v-if="showAccordionTC"></i>
                <i class="fa fa-caret-up" v-if="!showAccordionTC"></i>
                <span class="pl-5">{{$t('t_and_c')}}</span>
              </h6>
            </div>
            <collapse v-model="showAccordionTC" v-if="t_c_desc">
              <div class="menu-description " style="color:#d9b084"><nl2br tag="p" :text="t_c_desc" /></div>
            </collapse>
            <span class="add-toppings-str pl-10" v-if="addExtraTopping && addExtraTopping.length > 0 && convertExtraTopping()">
              <span class="text-green"><strong>{{$t('cart.add')}}: {{convertExtraTopping()}}</strong></span>
              <span class="content text-capitalize"></span>
            </span>
            <br>
            <span class="remove-toppings-str pl-10" v-if="removeYourTopping && removeYourTopping.length > 0">
              <span class="text-orange"><strong>{{$t('cart.remove')}}: {{removeYourTopping.map(f=>f.name).join(', ')}}</strong></span>
              <span class="content text-capitalize"></span>
            </span>
          </div>
          <div class="large-stuffed-crust">
            <div class="display-flex p10 text-black bg-grey-lightestest md:bg-transparent">
              <div class="flex1 display-flex items-center justify-start text-black t15 fw600">
                <div v-if="menu.first_layers && menu.first_layers.length > 0">{{$t('menu.select_size_crust')}}</div>
              </div>
            </div>
          </div>

          <div class="flex1auto selector-container" style="max-height: calc(100vh - 515px);">
            <!-- ############################## Choose size & crust ########################## -->
            <transition name="fade">
              <div class="box-select-variant-addon" v-if="!choosedName">
                <div v-for="item in menu.first_layers" :key="genUniqueKey(item)">
                  <div class="t15 fw600 chooseSize mt10 mb10 text-black  bg-white md:bg-transparent" :class="{'heading-line-right' : item.second_layers && item.second_layers.length > 0}">
                    <div class="p10" v-if="item.second_layers && item.second_layers.length > 0">{{item.name}}</div>
                    <div v-else class="variant-addon-item p10 option display-flex t15 bg-grey-lightestest md:bg-transparent active" @click="chooseVariant(item, {})">
                      <div class="flex1 text-black fw400" style="">
                        <span class="radio variant-addon-item-size text-black"></span>
                        <i class="pull-left"></i>
                        <span>{{item.name}}</span>
                      </div>
                      <div class="fw600 text-right pl10 pr10 flex-center">{{$const.CURRENCY}} {{ formatNum(item.price) }}</div>
                    </div>
                  </div>
                  <div v-for="subitem in item.second_layers" :key="genUniqueKey(subitem)"
                       class="variant-addon-item option display-flex t15 p10 text-black bg-grey-lightestest md:bg-transparent active"
                       @click="chooseVariant(item, subitem)">
                    <div class="flex1 display-flex items-center justify-start text-black fw400">
                      <div>
                        <img v-if="subitem.image" width="35" v-bind:alt="subitem.name"
                             v-bind:src="subitem.image.desktop_detail"
                             class="option---icon">
                      </div>
                      <div class="pl-10 option---content ">
                        <div>{{subitem.name}}</div>
                        <div class="option__long-description t13 fw400"></div>
                      </div>
                    </div>
                    <div class="fw600 text-right pl10 pr10 flex-center" v-if="menu.first_layers && menu.first_layers.length >= 1">
                      {{$const.CURRENCY}} {{ sumNum(menu.price, item.price, subitem.price) }}
                    </div>
                    <div class="fw600 text-right pl10 pr10 flex-center" v-else>{{$const.CURRENCY}} {{ formatNum(menu.price) }}</div>
                  </div>
                </div>
              </div>
            </transition>
            <!-- ################################################################################### -->
            <!-- ############################ Topping ###################################### -->
            <transition name="fade">
              <div class="p10 box-topping-contain" v-if="choosedName">
                <div class="variant-addon-choosen p10">
                  <div class="display-flex t15">
                    <span class="flex1 name fw400 text-black">{{choosedName}}</span>
                    <a @click="changeSize" class="cursor-pointer cl-78838c border-b t13">{{$t('button_change')}}</a>
                  </div>
                  <hr>
                </div>

                <div class="menu-toppings">
                  <!--------------------View Cheese------------------>
                  <div v-if="maxExtra != 0">
                    <div>
                      <div v-for="(citem) in cheese" :key="'parent'+citem.parent" :id="'parent'+citem.parent" >
                        <div class="topping-header"
                             role="button"
                             @click="toggleAccordion(show.cheese,2)"
                             :class="{active: show.cheese}">
                          <div class="bold" style="font-size: 15px;">
                            {{ citem.name }}
                            <i class="fa fa-caret-up"></i>
                          </div>
                        </div>

                        <collapse v-model="show.cheese">
                          <div v-for="(topping,index) in citem.arr" :key="'chil'+index">
                            <div class="variant-addon-item optixron display-flex t15 p10 bg-grey-lightestest md:bg-transparent topping-cheese"
                                 v-bind:class="{'disabled' : (topping.isDisable || !allow_cheese)}"
                                 @click="changeTopping(topping,3,index)">
                              <div class="flex1 text-black fw400">
                                <span class="radio variant-addon-item-size text-black" v-bind:class="{'checked' : (sauceAndCheese.sauce && sauceAndCheese.sauce.name == topping.name) || (sauceAndCheese.cheese && sauceAndCheese.cheese.name == topping.name)}"></span>
                                <i class="pull-left"></i> <span>{{topping.name}}</span>
                              </div>
                              <div v-if="getPriceTopping(topping.prices)> 0" class="text-right pl10 pr10 topping-price fw600 cl-525252" style="">+{{$const.CURRENCY}}
                                {{ formatNum(getPriceTopping(topping.prices)) }}
                              </div>
                              <div class="fw600 text-right pl10 pr10 pull-right"><span class="stick" v-if="(sauceAndCheese.sauce && sauceAndCheese.sauce.name == topping.name) || (sauceAndCheese.cheese && sauceAndCheese.cheese.name == topping.name)"></span></div>
                            </div>
                          </div>
                        </collapse>
                      </div>
                    </div>
                    <!--<div v-else>-->
                      <!--<div class="topping-header"-->
                           <!--role="button"-->
                           <!--@click="fchangeSauce(sauceAndCheese.cheese,changeSauce.cheese,2)">-->
                        <!--<div class="bold" style="font-size: 15px;">-->
                          <!--{{$t('your_cheese')}}-->
                          <!--<i class="fa fa-caret-up"></i>-->
                        <!--</div>-->
                      <!--</div>-->
                      <!--<div class="line w-full"></div>-->
                      <!--<div class="variant-addon-item option display-flex t15 p10 bg-grey-lightestest md:bg-transparent">-->
                        <!--<div class="flex1 text-black fw400">-->
                          <!--<span class="radio variant-addon-item-size text-black checked panel-title"></span>-->
                          <!--<i class="pull-left"></i> <span>{{sauceAndCheese.cheese.name}}</span>-->
                        <!--</div>-->
                        <!--<div v-if="getPriceTopping(sauceAndCheese.cheese.prices) > 0 " class="text-right pl10 pr10 topping-price fw600 cl-525252" style="">+{{$const.CURRENCY}}-->
                          <!--{{ formatNum(getPriceTopping(sauceAndCheese.cheese.prices)) }}-->
                        <!--</div>-->
                        <!--<div class="cursor-pointer cl-78838c border-b t13 pull-right" @click="fchangeSauce(sauceAndCheese.cheese,changeSauce.cheese,2)">Change</div>-->
                      <!--</div>-->
                    <!--</div>-->
                  </div>

                  <!--------------------Your Topping------------------>
                  <div v-if="$const.SIZE_RESTRICT_TOPPING.indexOf(choosedFirst.sku || '') < 0 && maxExtra !== 0">
                    <div class="topping-header" style=""
                         v-if="yourTopping && yourTopping.length > 0"
                         @click="showToppingPlus = !showToppingPlus"
                         :class="{active: showToppingPlus}">
                      {{$t('your_toppings')}}
                      <i class="fa fa-caret-up"></i>
                    </div>
                    <collapse v-model="showToppingPlus" v-if="$const.SIZE_RESTRICT_TOPPING.indexOf(choosedFirst.sku || '') < 0">
                      <div class="your-toppings text-black" style="" v-if="yourTopping && yourTopping.length > 0 ">
                        <transition-group name="fade" v-on:before-leave="beforeLeaveTopping" v-on:after-leave="afterLeaveTopping">
                          <div class="your-toppings-item display-flex t15 p10 cursor-pointer option visible"
                               style="" v-for="(topping,index) in yourTopping" :key="genUniqueKey(topping)"
                               v-bind:class="{'disable': topping.isDisable }"
                               @click="changeTopping(topping,1,index)"
                          >
                            <div class="flex1 fw400">
                              <img v-bind:src="topping.image.desktop_thumbnail" width="24" height="2">
                              <span class="pl-10">{{topping.name}}</span>
                            </div>
                            <div class=" text-right pl10 pr10 topping-price fw600 cl-525252" v-if="!topping.default">+{{$const.CURRENCY}}
                              {{ formatNum(getPriceTopping(topping.prices)) }}
                            </div>
                            <div class="bold text-right pl10 pr10">
                              <img src="https://static.phdvasia.com/jp/icons/remove.svg"
                                   class="cursor-pointer" alt="remove">
                            </div>
                          </div>
                        </transition-group>
                      </div>
                    </collapse>
                  </div>

                  <!--------------------Your Topping When Max Extra Equal 0------------------>
                  <div v-if="$const.SIZE_RESTRICT_TOPPING.indexOf(choosedFirst.sku || '') < 0 && maxExtra === 0">
                    <div class="topping-header" style=""
                         v-if="yourTopping && yourTopping.length > 0"
                         @click="showToppingPlus = !showToppingPlus"
                         :class="{active: showToppingPlus}">
                      {{$t('your_toppings')}}
                      <i class="fa fa-caret-up"></i>
                    </div>
                    <collapse v-model="showToppingPlus" v-if="$const.SIZE_RESTRICT_TOPPING.indexOf(choosedFirst.sku || '') < 0">
                      <div class="your-toppings text-black" style="" v-if="yourTopping && yourTopping.length > 0 ">
                        <transition-group name="fade" v-on:before-leave="beforeLeaveTopping" v-on:after-leave="afterLeaveTopping">
                          <div class="your-toppings-item display-flex t15 p10 cursor-pointer option visible"
                               style="" v-for="(topping,index) in yourTopping" :key="genUniqueKey(topping)"
                               v-bind:class="{'disable': topping.isDisable }"
                               @click="removeYourToppingNewDesign(topping,1,index)"
                          >
                            <div class="flex1 fw400">
                              <img v-bind:src="topping.image.desktop_thumbnail" width="24" height="2">
                              <span class="pl-10">{{topping.name}}</span>
                            </div>
                            <div class=" text-right pl10 pr10 topping-price fw600 cl-525252" v-if="!topping.default">+{{$const.CURRENCY}}
                              {{ formatNum(getPriceTopping(topping.prices)) }}
                            </div>
                            <span v-if="checkAvailableAddYourTopping(topping)" class="add-icon mr-0 ml-5 fa-plus-icon ">
                                <i class="add-icon__v"></i>
                                <i class="add-icon__h"></i>
                            </span>
                            <div v-else class="bold text-right pl10 pr10">
                              <img src="https://static.phdvasia.com/my/icons/remove.svg"
                                   class="cursor-pointer" alt="remove">
                            </div>
                          </div>
                        </transition-group>
                      </div>
                    </collapse>
                  </div>

                  <!--------------------Extra Topping------------------>
                  <div v-if="$const.SIZE_RESTRICT_TOPPING.indexOf(choosedFirst.sku || '') < 0 && (maxExtra != 0 || show_extra_topping)">
                    <div class="topping-header" style=""
                         v-if="extraTopping && extraTopping.length > 0"
                         @click="showToppingMinus = !showToppingMinus"
                         :class="{active: showToppingMinus}">
                      {{$t('add_toppings')}}
                      <i class="fa fa-caret-up"></i>
                    </div>
                    <collapse v-model="showToppingMinus" v-if="$const.SIZE_RESTRICT_TOPPING.indexOf(choosedFirst.sku || '') < 0">
                      <div class="add-toppings text-black" style="" v-if="extraTopping && extraTopping.length > 0">
                        <transition-group name="fade">
                              <div v-for="(extopping,index) in extraTopping" :key="genUniqueKey(extopping)"
                                   v-if="(extopping.special != '1')"
                                   class="add-toppings-item display-flex t15 p10 cursor-pointer option bg-grey-lightestest md:bg-transparent"
                                   v-bind:class="{'disable': extopping.isDisable }" @click="changeTopping(extopping, 2, index)">
                                <div class="flex1 fw400 ">
                                  <img v-bind:src="extopping.image.desktop_thumbnail" width="24" height="24">
                                  <span class="pl-10">{{extopping.name}}</span>
                                </div>
                                <div class="text-right pl10 pr10 topping-price fw600 cl-525252" style="" v-if="!extopping.default">+{{$const.CURRENCY}}
                                  {{ formatNum(getPriceTopping(extopping.prices)) }}
                                </div>
                                <div class="bold text-right pl10 pr10">
                              <span class="add-icon mr-0 ml-5 fa-plus-icon ">
                                <i class="add-icon__v"></i>
                                <i class="add-icon__h"></i>
                            </span>
                                  <img src="https://static.phdvasia.com/jp/icons/remove.svg"
                                       class="cursor-pointer fa-remove-image" alt="remove" style="display: none">
                                </div>
                              </div>
                            </transition-group>
                      </div>
                    </collapse>
                  </div>
                  <!--</div>-->
                  <!--</div>-->
                </div>
              </div>
            </transition>
            <!-- ############################################################################ -->
          </div>
          <div v-if="isAppOnly" class="modal-action">
            <a target="_blank" :href="linkAppOnly" type="button" class="btn btn-lg btn-danger full text-center">
              {{$t('get_the_app_now')}}
            </a>
          </div>
          <div v-else class="modal-action">
            <!--<button type="button" @click="gotoHalf(menu)" class="btn btn-lg btn-success full  js-action-btn-add btn-half" v-if="menu.piece == $const.HALF_HALF_ID">{{$t('btn_hatf_halt')}}</button>-->
            <button type="button" @click="addToBasket()" class="btn btn-lg btn-success full  js-action-btn-add"
                    v-bind:class="{disabled : disableAdd}" v-if="menu.first_layers && menu.first_layers.length > 0">{{$t('add_to_my_basket')}} <span>+{{$const.CURRENCY}} <span
              class="total-price">{{ formatNum(totalPrice) }}</span></span></button>
            <button type="button" @click="addToBasket()" class="btn btn-lg btn-success full  js-action-btn-add"
                    v-else>{{$t('add_to_my_basket')}} <span>+{{$const.CURRENCY}} <span
              class="total-price">{{ formatNum(menu.price) }}</span></span></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import * as action from '@/store/actions'
  import {mapGetters, mapActions} from 'vuex'
  import {VueTabs, VTab} from 'vue-nav-tabs'
  import 'vue-nav-tabs/themes/vue-tabs.css'
  export default {
    props: ['menu', 'mfirst', 'msecond', 'extraCheese', 'coupon'],
    mounted () {
      this.itemId = this.selectedCart ? this.selectedCart.cartId : null
      this.getTopping()
      this.resizePopup()
      if (!this.empty(this.mfirst) && !this.empty(this.msecond)) {
        this.chooseVariant(this.mfirst, this.msecond)
      } else {
        this.eventTrackingProductView(null, this.menu, this)
      }
      this.buildListTopping(this.menu)
      this.eventTrackingProductDetail(this, this.menu, this.$const.CARD_ITEM_TYPE.SINGLE)
      this.isAppOnly = this.getValueFromAttr(this.menu, 'customize.promote_for_download_app', false)
      this.linkAppOnly = this.getValueFromAttr(this.menu, 'customize.deep_link_download_app', '')
    },
    components: {
      VueTabs,
      VTab
    },
    computed: {
      ...mapGetters({
        selectedCart: 'selectedCart',
        shouldTriggerChooseTopping: 'shouldTriggerChoosingTopping'
      })
    },
    destroyed() {
      let sub = this.$route.params.sub;
      let uuid = this.$route.params.uuid;
      this.setUuidForNameseoDuplicate('')
      document.body.classList.remove('modal-open')
      this.$store.commit('setSelectedCart', null)
      if (uuid) {
        this.redirectToMenuPage(this.$route.params.slug, sub, null, true);
      } else {
        this.redirectToMenuPage(this.$route.params.slug, null, null, true);
      }
    },
    watch: {
      choosedCheese (val) {
        this.updateTotalPrice()
        if (parseInt(this.addExtraTopping.length) + parseInt(val.length) >= this.maxExtra) {
          this.showAllExtraTopping(true)
        } else {
          this.showAllExtraTopping(false)
        }
      },
      picked_radio (val) {
        if(val){
          this.chooseSauceCheese(val)
        }
      },
      allow_cheese (val) {
        if(!val){
          this.addExtraTopping.map((extra,index) => {
            if(this.isCheese(extra)){
              this.changeTopping(extra,3, 'ignore')
            }
          })
        }
      }
    },
    data: function () {
      return {
        choosedName: '',
        defaultsTopping: [],
        defaultsextraTopping: [],
        yourTopping: [],
        extraTopping: [],
        choosedFirst: {},
        choosedSecond: {},
        removeYourTopping: [],
        addExtraTopping: [],
        totalPrice: 0,
        totalExtraTopping: 0,
        transitionLeave: true,
        choosedCheese: [],
        gotCheese: { 'status': 'N', 'price': 0 },
        maxExtra: this.menu && this.menu.max_extra >= 0 ? this.menu.max_extra : this.$const.MAX_TOPPING,
        maxRemoveTopping : this.menu && this.menu.max_topping >= 0 ? this.menu.max_topping : this.$const.MAX_REMOVE_TOPPING,
        addExtraToppingWithPrice: [],
        disableAdd: true,
        t_c_desc: this.menu.t_and_c,
        showAccordionTC: false,
        choosedHalf: false,
        showExtra: false,
        showAccordion: [true,true],
        extra_cheese: [],
        radio_selected: [],
        picked_radio: {},
        sauce: [],
        cheese: [],
        new_sauce: [],
        product: this.menu ? this.menu : null,
        sauceAndCheese: {
          sauce: {},
          cheese: {}
          },
        changeSauce: {sauce: false, cheese: false},
        show: {sauce: true, cheese: true},
        showToppingMinus: true,
        showToppingPlus: true,
        show_new_sauce: false,
        allow_cheese : true /*new logic for My*/,
        show_extra_topping : true,
        isAppOnly: false,
        linkAppOnly: ''
      }
    },
    methods: {
      ...mapActions({
        setUuidForNameseoDuplicate: action.SET_UUID_FOR_NAMESEO_DUPLICATE
      }),
      removeYourToppingNewDesign(topping) {
        if (!topping.isDisable) {
          this.eventTrackingVariantUnSelect({item: this.menu, topping: topping, first: this.choosedFirst})
          // if remove isExtra topping
          this.updateTotalPrice()
          if(!this.checkAvailableAddYourTopping(topping)){
            this.removeYourTopping.push(topping)
          }else{
            this.sliceTopping(topping, 2)
          }
          if(this.removeYourTopping.length === this.maxRemoveTopping){
            this.yourTopping.map(yourtopping => {
              if(!this.checkAvailableAddYourTopping(yourtopping))
                yourtopping.isDisable = true
            })
          }else{
            this.yourTopping.map(yourtopping => {
                yourtopping.isDisable = false
            })
          }
        }
      },
      checkAvailableAddYourTopping(topping) {
        let result = 0
        if(this.removeYourTopping.length > 0){
          this.removeYourTopping.map(ex => {
            if(ex.id == topping.id){
              result++
            }
          })
        }
        return result > 0 ? true : false
      },
      checkHideExtraCheese() {
        let result = false
        this.extraTopping.map(extra => {
          if(extra.isDisable === false){
            result = true
          }
        })
        this.show_extra_topping = result
      },
      /**
       * check visible or disable extra cheese
       * */
      checkAllowCheese() {
        let addCheese = 0
        let removeCheese = 0
        this.removeYourTopping.map(remove => {
          if(this.isCheese(remove)) {
            removeCheese++
          }
        })
        this.addExtraTopping.map(topping => {
          if(this.isCheese(topping)) {
            addCheese++
          }
        })
        this.allow_cheese = (removeCheese < addCheese || removeCheese === 0)
      },
      fchangeSauce(topping,status,type){
        if(type == 1){
          this.changeSauce.sauce = !status
        }else if(type == 2){
          this.changeSauce.cheese = !status
        }
      },
      buildListTopping(data){
        if(data&&data.toppings&&data.toppings.extra){
          let sauce=[],cheese=[] , new_sauce = []
          for (let p in data.toppings.extra) {
            let parent = data.toppings.extra[p]
            parent.isDisable = this.maxExtra === 0 ? true : false
            if(parent){
              if(parent.special==2){
                parent.parent=1
                sauce.push(parent)
                if(parent.sku == this.$const.SKU_DEFAULT_TOPPING){
                  this.show.sauce = true
                  this.changeSauce.sauce = false
                  this.sauceAndCheese.sauce.name = parent.name
                }
              }else if(parent.special==1){
                parent.parent=2
                cheese.push(parent)
                // default topping
                if(parent.sku == this.$const.SKU_DEFAULT_TOPPING){
                  this.sauceAndCheese.cheese.name = parent.name
                  this.changeSauce.cheese = false
                  this.show.cheese = true
                }
              } else if(parent.special == 3){
                parent.parent = 3
                new_sauce.push(parent)
              }
            }
          }
          sauce.sort(function(a, b){
            if(a.sequence > 0)
              return a.sequence - b.sequence
            else{
              return -10
            }
          });
          cheese.sort(function(a, b){
            if(a.sequence > 0)
              return a.sequence - b.sequence
            else{
              return -10
            }
          });
          if(sauce.length > 0)
            this.sauce.push({'name':this.$t('your_base_sauce'),'arr':sauce,'parent':1,'show':true})
          if(cheese.length > 0)
            this.cheese.push({'name':this.$t('your_cheese'),'arr':cheese,'parent':2,'show':true})
          if(new_sauce.length > 0)
            this.new_sauce = new_sauce
        }
      },
      toggleAccordion (status,type) {
        if(type == 1)
          this.show.sauce = !this.show.sauce
        else if(type == 2)
          this.show.cheese = !this.show.cheese
      },
      checkDisableExtra (uuid) {
        let exist = false
        for (let i in this.choosedCheese) {
          if (uuid == this.choosedCheese[i].uuid) {
            exist = true
          }
        }
        if (!exist && parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) >= this.maxExtra) {
          return true
        }

        if (exist && parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) < this.maxExtra) {
          return false
        }

        return false
      },
      /**
       * Trigger before leave topping event
       */
      beforeLeaveTopping (el) {
        this.transitionLeave = false
      },
      /**
       * Trigger after leave topping event
       */
      afterLeaveTopping (el) {
        this.transitionLeave = true
      },
      /**
       * Chosen first and second layer
       */
      chooseVariant (first, second) {
        this.choosedFirst = first
        this.choosedSecond = second
        this.choosedName = (first.name + ' ' + (second.name || '')).trim()
        this.updateTotalPrice()
        this.$set(this.gotCheese, 'status', this.menu.extraCheese)
        this.$set(this.gotCheese, 'price', this.getCheese(first.name))
        this.disableAdd = false

        let product = this.lodash.cloneDeep(this.product)
        let choosedFirst = this.lodash.cloneDeep(first)
        let choosedSecond = this.lodash.cloneDeep(second)
        product.first_layers = []
        product.first_layers.push(choosedFirst)
        product.first_layers[0].second_layers = []
        if (first != null && !this.empty(first) && !this.empty(second)) {
          product.first_layers[0].second_layers = [choosedSecond]
        }
        product.price = this.totalPrice
        let proClick = this._.cloneDeep(this.product)
        let variantUUid = ''
        if (!this.empty(first) && first.uuid != '') {
          variantUUid = first.uuid
        }
        if (!this.empty(second) && second.uuid != '') {
          variantUUid += '-' + second.uuid
        }
        proClick.variant_uuid = variantUUid
        this.evenTrackingProductClick(this, proClick, 'product-selection-from-variant-list')
        this.eventTrackingProductDetail(this, product, this.$const.CARD_ITEM_TYPE.SINGLE, 'product-details')
        this.eventTrackingProductView(variantUUid, product, this)
        this.smartechViewProduct(this,product,first,second,this.$router)
      },
      /**
       * Get cheese price belong size pizza
       * */
      getCheese (size) {
        let price = 0
        for (let cheese in this.extracheese) {
          if (this.extracheese[cheese].Size == this.convertString(size)) { price = this.extracheese[cheese].Price }
        }
        return price
      },
      /**
       * Get topping price
       * */
      getPriceTopping (topping) {
        let price = 0
        if (topping) {
          price = topping[this.choosedFirst.sku] ? topping[this.choosedFirst.sku] : 0
        } else {
          price = 0
        }

        return price
      },
      /**
       * Reset item choiced
       * */
      resetDataItem () {
        this.choosedFirst = {}
        this.choosedName = ''
        this.totalPrice = 0
        this.removeYourTopping = []
        this.addExtraTopping = []
        this.yourTopping = JSON.parse(JSON.stringify(this.defaultsTopping))
        this.extraTopping = JSON.parse(JSON.stringify(this.defaultsextraTopping))
        this.totalExtraTopping = 0
        this.choosedCheese = []
        this.sauceAndCheese.sauce = {}
        this.sauceAndCheese.cheese = {}
        this.sauceAndCheese.new_sauce = {}
        this.changeSauce.sauce = false
        this.changeSauce.cheese = false
        this.show.sauce = true
        this.show.cheese = true
        this.allow_cheese = true
        this.cheese.map(cheeses => {
          cheeses.arr.map(cheese => {
            cheese.isDisable = false
          })
        })
      },
      /**
       * reset first and second layer
       * */
      changeSize () {
        this.resetDataItem()
        this.disableAdd = true
      },
      /**
       * change your topping
       * type: 1: remove topping, 2 add topping
       * */
      changeTopping (topping, type, index) {
        let newTopping = JSON.parse(JSON.stringify(topping))
        let uncheckFlag = false
        if (this.transitionLeave) {
          if (type == 1) {
            if (!topping.isDisable) {
              this.eventTrackingVariantUnSelect({item: this.menu, topping: topping, first: this.choosedFirst})
              this.yourTopping.splice(index, 1)
              // if remove isExtra topping
              if (!topping.default || (topping.default && !this.checkToppingType(topping, 2))) {
                this.sliceTopping(topping, 3)
                this.updateTotalPrice()
              } else {
                this.removeYourTopping.push(topping)
              }
              this.updateExtra(topping, type)
              this.checkDisableTopping(topping, type)
            }
          } else if (type == 2) {
            if (!topping.isDisable) {
              newTopping.default = this.checkToppingType(newTopping, 2)
              this.eventTrackingVariantSelect({item: this.menu, topping: topping, first: this.choosedFirst})
              if (!newTopping.default) {
                this.addExtraTopping.push(newTopping)
                this.updateTotalPrice()
              } else {
                this.sliceTopping(topping, 2)
              }
              this.yourTopping.push(newTopping)
              this.updateExtra(newTopping, type)
              this.checkDisableTopping(newTopping, type)
            }
          }else if (type == 3) {
            if(newTopping.parent == 1){
              if(this.sauceAndCheese.sauce){
                this.sliceTopping(this.sauceAndCheese.sauce, 1)
                for(let exs of this.addExtraTopping){
                  if(exs.id == newTopping.id)
                    return;
                }
                this.changeSauce.sauce = true
                this.sliceTopping(this.sauceAndCheese.sauce, 3)
              }
              this.sauceAndCheese.sauce = newTopping
              this.changeSauce.sauce = true
            }else if(newTopping.parent == 2){
              if(this.sauceAndCheese.cheese){
                if(index !== 'ignore' && (this.allow_cheese === false || newTopping.isDisable)) {
                   return false
                }
                this.sliceTopping(this.sauceAndCheese.cheese, 1)
                for(let exc of this.addExtraTopping){
                  if(exc.id == newTopping.id) {
                    // uncheck
                    uncheckFlag = true;
                    // return;
                  }
                }
                this.sliceTopping(this.sauceAndCheese.cheese, 3)

              }
              this.changeSauce.cheese = !uncheckFlag;
              this.sauceAndCheese.cheese = uncheckFlag ? {} : newTopping;

              if (uncheckFlag) {
                this.updateTotalPrice()
                this.checkDisableTopping(newTopping, 2)
                return true;
              }
            }
            if(newTopping.id != ''){
              this.addExtraTopping.push(newTopping)
            }
            this.updateTotalPrice()
            this.checkDisableTopping(newTopping, 2)
          }
          this.checkRemoveTopping()
          this.checkAllowCheese()
          this.checkHideExtraCheese()
        }
      },
      /**
       * update total price
       * */
      updateTotalPrice () {
        this.totalExtraTopping = 0
        for (let topping in this.addExtraTopping) {
          this.totalExtraTopping += parseFloat(this.getPriceTopping(this.addExtraTopping[topping].prices))
        }
        this.totalPrice = this.menu.price > 0 ? parseFloat(this.menu.price) : 0
        this.totalPrice += this.totalExtraTopping
        if (typeof this.choosedFirst.price !== 'undefined') {
          this.totalPrice += parseFloat((this.choosedFirst.price > 0 ? this.choosedFirst.price : 0))

        }
        if (typeof this.choosedSecond.price !== 'undefined') {
          this.totalPrice += parseFloat(this.choosedSecond.price || 0)
        }
        let extraPrice = 0
        for (let i in this.choosedCheese) {
          extraPrice += parseFloat(this.getPriceTopping(this.choosedCheese[i].prices))
        }
        this.totalPrice += parseFloat(extraPrice)
      },
      /**
       * Slice topping
       * type: 1: your topping, 2 remove your topping, 3 add topping (default)
       * */
      sliceTopping (topping, type) {
        if (type == 1) {
          for (let y in this.yourTopping) {
            if (this.yourTopping[y].id == topping.id) {
              this.yourTopping.splice(y, 1)
              break
            }
          }
        } else if (type == 2) {
          for (let y in this.removeYourTopping) {
            if (this.removeYourTopping[y].id == topping.id) {
              this.removeYourTopping.splice(y, 1)
              break
            }
          }
        } else {
          for (let y in this.addExtraTopping) {
            if (this.addExtraTopping[y].id == topping.id) {
              this.addExtraTopping.splice(y, 1)
              break
            }
          }
        }
      },
      isCheese(item) {
        let result = item.name && item.name.match(/cheese/i) !== null
        return result
      },
      /**
       * set your and extra toppings
       * */
      getTopping () {
        const vm = this
        if (this.menu.toppings && this.menu.toppings.default && this.menu.toppings.extra) {
          let data = JSON.parse(JSON.stringify(this.menu.toppings.default))
          for (let topping in data) {
            data[topping].default = true
            data[topping].isDisable = this.maxRemoveTopping === 0 ? true : false
            if (vm.isCheese(data[topping])) {
              data[topping].isCheese = true
            }
          }
          this.yourTopping = data
          this.extraTopping = JSON.parse(JSON.stringify(this.menu.toppings.extra))
          //get extra topping except sauce and extra cheese begin
          let tmpExtraTopping = []
          for(let ex of this.extraTopping){
            if(ex.special == 0){
              tmpExtraTopping.push(ex)
            }
          }
          //get extra topping except sauce and extra cheese end
          this.extraTopping = tmpExtraTopping
          this.showExtra = false
          for (let topping in this.extraTopping) {
            this.extraTopping[topping].default = false
            if (this.maxExtra == 0) {
              this.extraTopping[topping].isDisable = true
            } else {
              this.extraTopping[topping].isDisable = false
            }
            if (this.extraTopping[topping].special == '1') {
              this.showExtra = true
            }
          }
          this.defaultsTopping = JSON.parse(JSON.stringify(this.yourTopping))
          this.defaultsextraTopping = JSON.parse(JSON.stringify(this.extraTopping))

        }
        this.checkHideExtraCheese()
      },
      /**
       * check topping is extra or default
       * type: 1 isExtra, 2 Default
       * */
      checkToppingType (topping, type) {
        let i = 0
        for (let t in this.defaultsTopping) {
          if (this.defaultsTopping[t].id == topping.id) { i++ }
        }
        if (i == 0) {
          return type == 1
        }
        i = 0
        for (let t in this.yourTopping) {
          if (this.yourTopping[t].id == topping.id) { i++ }
        }
        if (type == 1) {
          return i > 0
        }
        return i == 0
      },
      /**
       * re-update extra and default toppings
       * type: 1 remove topping, 2 add topping
       * */
      updateExtra (topping, type) {
        for (let t in this.extraTopping) {
          if (this.extraTopping[t].id == topping.id) {
            if (type == 1) {
              if (topping.default && this.yourTopping.length > 0) {
                this.extraTopping[t].default = true
                for (let y in this.yourTopping) {
                  if (this.yourTopping[y].id == topping.id) {
                    this.yourTopping[y].default = true
                    this.extraTopping[t].default = false
                    break
                  }
                }
              } else {
                this.extraTopping[t].default = topping.default
              }
            } else {
              this.extraTopping[t].default = false
            }
            break
          }
        }
      },
      /*
      * Check max per topping
      * */
      isAvalableTopping(topping){
        if(this.addExtraTopping && this.addExtraTopping.length > 0){
          let count = 0
          for(let i of this.addExtraTopping){
            if(i.id == topping.id){
              count++
            }
          }
          return (count >= this.$const.NUM_OF_MAX_PER_TOPPING) ? true : false
        }else{
          return false
        }
      },
      checkRemoveTopping(){
        if(this.removeYourTopping.length >= this.maxRemoveTopping){
          this.yourTopping.map(topping => {
            if (topping.default) {
              topping.isDisable = true
            }
          })
        }else{
          this.yourTopping.map(topping => {
            topping.isDisable = false
          })
        }
      },
      /**
       * Check to show/hide extra topping
       * type: 1 remove topping, 2 add topping (default)
       * */
      checkDisableTopping (topping, type) {
        if (parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) >= this.maxExtra) {
          this.updateDisableExtraTopping()
          let hasAddCheese = 0
          this.addExtraTopping.map(topping => {
            if (this.isCheese(topping)) {
              hasAddCheese++
            }
          })
          this.cheese.map(cheeses => {
            cheeses.arr.map(cheese => {
                  cheese.isDisable = !hasAddCheese
                })
          })
        } else {
          if (topping.default) {
            if (type == 1) {
              if (this.removeYourTopping.length > 0 && parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) >= this.maxExtra) {
                for (let t in this.extraTopping) {
                  for (let rm in this.removeYourTopping) {
                    if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
                      this.extraTopping[t].isDisable = this.isAvalableTopping(this.extraTopping[t])
                      break
                    }
                  }
                }
              } else {
                this.showAllExtraTopping(false)
              }
            } else if (type == 2) {
              for (let t in this.extraTopping) {
                for (let rm in this.removeYourTopping) {
                  if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
                    this.extraTopping[t].isDisable = this.isAvalableTopping(this.extraTopping[t])
                    break
                  }
                }
              }
            }else if (type == 3) {
              for (let t in this.extraTopping) {
                for (let rm in this.removeYourTopping) {
                  if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
                    this.extraTopping[t].isDisable = this.isAvalableTopping(this.extraTopping[t])
                    break
                  }
                }
              }
            }
          } else {
            if (type == 1) {
              this.showAllExtraTopping(false)
              this.cheese.map(cheeses => {
                cheeses.arr.map(cheese => {
                  cheese.isDisable = false
                })
              })
            } else {
              let disable
              if (this.removeYourTopping.length > 0 && parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) < this.maxExtra) {
                for (let t in this.extraTopping) {
                  for (let rm in this.removeYourTopping) {
                    if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
                      disable = false
                      break
                    } else {
                      if (!this.extraTopping[t].default) { disable = this.isAvalableTopping(this.extraTopping[t]) }
                    }
                    disable = this.isAvalableTopping(topping)
                    this.extraTopping[t].isDisable = disable
                  }
                }
              } else {
                if (parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) == this.maxExtra) {
                  for (let t in this.extraTopping) {
                    this.extraTopping[t].isDisable = this.isAvalableTopping(this.extraTopping[t])
                  }
                  for (let ns in this.new_sauce){
                    this.new_sauce[ns].isDisable = this.isAvalableTopping(this.new_sauce[ns])
                  }
                }else{
                  for (let ex of this.extraTopping) {
                    ex.isDisable = this.isAvalableTopping(ex)
                  }

                  for (let ns in this.new_sauce){
                    this.new_sauce[ns].isDisable = this.isAvalableTopping(this.new_sauce[ns])
                  }
                }
              }
            }
          }
        }
      },
      /**
       * Checking to show/hide extra topping
       * */
      updateDisableExtraTopping () {
        for (let t in this.extraTopping) {
          let disable = true
          if (this.removeYourTopping.length > 0) {
            for (let rm in this.removeYourTopping) {
              if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
                disable = false
                break
              }
            }
          } else {
            if (!this.extraTopping[t].default) { disable = true }
          }
          this.extraTopping[t].isDisable = disable
        }
      },
      /**
       * Show extra topping
       * */
      showAllExtraTopping (flag) {
        for (let t in this.extraTopping) {
          this.extraTopping[t].isDisable = this.isAvalableTopping(this.extraTopping[t])
        }
        for (let ns in this.new_sauce) {
          this.new_sauce[ns].isDisable = this.isAvalableTopping(this.new_sauce[ns])
        }
      },

      getToppingById (a) {
        var arr = []
        for (let i = 0; i < a.length; i++) {
          arr.push(a[i].id)
        }
        return arr
      },

      checkSubmit () {
        if (this.menu.first_layers && this.menu.first_layers.length > 0) {
          if (this.choosedName.length > 0) {
            return true
          } else {
            return false
          }
        } else {
          if (this.menu.name.length > 0) {
            return true
          } else {
            return false
          }
        }
      },

      /**
       * Adding item to cart
       * Prepare new format to API
       * */
      addToBasket () {
        if (this.checkSubmit()) {
          let item = {
            'group': {},
            'selling_start': this.menu.selling_start,
            'products': []
          }
          if (this.coupon) {
            item.group.coupon_code = this.coupon
          }
          item.group['outlet_code'] = this.getOutletCode(this)
          item.group['tier'] = this.$cart.tier
          item.group['order_type'] = this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
          item.group['order_time'] = this.getTimePickerDate(this)
          item.group['product_type'] = this.menu.product_type
          item.group['combo_id'] = null
          item.group['quantity'] = 1

          let product = {}
          let filterExtra = []
          product.category_id = this.$cart.category_id
          product.combo_group_id = ''
          product.product_id = this.menu.uuid
          product.first_id = this.choosedFirst.uuid
          product.second_id = this.choosedSecond.uuid
          product.toppings = {}
          product.toppings.remove = this.$cart.getToppingById(this.removeYourTopping)
          for(let filter of this.addExtraTopping){
              if(filter.sku != this.$const.SKU_DEFAULT_TOPPING){
                filterExtra.push(filter)
              }
          }
          this.addExtraTopping = filterExtra
          let newExtraTopping = this.lodash.union(this.addExtraTopping, this.choosedCheese)
          product.toppings.extra = this.$cart.getToppingById(newExtraTopping)
          item.products.push(product)
          this.$emit('close')
          if (this.itemId) {
            item.group['item_id'] = this.itemId
            this.$cart.updateCart(this, item)
          } else {
            this.$cart.insert(this, item)
          }

          let pro = {
            item: this.menu,
            id: this.product.uuid,
            quantity: 1,
            name: this.product.name,
            price: this.totalPrice,
            first: this.choosedFirst || {},
            second: this.choosedSecond || {},
            context: 'product'
          }
          this.resetDataItem()
          this.smartechAddItem(this, pro , this.$router)
          pro.item.item_price = pro.price
          this.eventTrackingAddToCart(this, pro, 'main', this.$const.CARD_ITEM_TYPE.SINGLE)
        }
      },
      /**
       * resize height modal popup
       * */
      resizePopup () {
        let headH = this.$el.querySelector('.modal-head').scrollHeight + this.$el.querySelector('.modal-action').scrollHeight
        if (window.innerWidth > 768) {
          headH = 350
        } else {
          headH -= 10
        }
        let maxH = window.innerHeight - headH
        this.$el.querySelector('.selector-container').style['max-height'] = maxH + 'px'
      },
      /**
       * Go to Half & Half page opt
       * */
      gotoHalf (item) {
        this.$emit('close')
        this.$modal.show(ModalHalf, {
          item: item,
          scrollable: false
        }, { class: 'modal-menu', transition: 'nice-modal-fade', overlayTransition: 'overlay-fade', clickToClose: false, name: 'close-modal-menu' })
      },
      convertExtraTopping(){
        let extra = []
        for(let i of this.addExtraTopping){
          if(i.sku != this.$const.SKU_DEFAULT_TOPPING)
            extra.push(i.name)
        }
        return extra.join(', ')
      }
    }
  }

</script>
<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    /*transition: opacity .5s;*/
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    /*transition: opacity .3s ease;*/
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 300px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    /* transition: all .3s ease; */
    font-family: Helvetica, Arial, sans-serif;
  }
  .stick {
    display:inline-block;
    content: '';
    display: block;
    width: 7px;
    height: 15px;
    border: solid gray;
    border-width: 0 3px 3px 0px;
    transform: rotate(45deg);
  }
  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .btn-half {
    margin: 0px 0px 15px;
  }
  .modal-content{
    border-radius: 0px !important;
  }
  a:active {
    text-decoration: underline;
  }
</style>
<style scoped>
  /* The container */
  .container-radio {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    font-weight: 400 !important;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default radio button */
  .container-radio input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
  }

  /* On mouse-over, add a grey background color */
  .container-radio:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the radio button is checked, add a blue background */
  .container-radio input:checked ~ .checkmark {
    background-color: #2196F3;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  .container-radio input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .container-radio .checkmark:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
  .line {
    border: 0.5px solid #e2e2e2;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalPizza.vue